export const LogoMark = ({ className = "", size = 30 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id="acg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#A78BFA" />
        <stop offset="1" stopColor="#22D3EE" />
      </linearGradient>
    </defs>
    {/* Arc / Centum mark: an "A" arch over a central core */}
    <path
      d="M20 4 L35 34 H28.5 L20 15.5 L11.5 34 H5 L20 4 Z"
      stroke="url(#acg)"
      strokeWidth="2"
      strokeLinejoin="round"
      fill="none"
    />
    <circle cx="20" cy="26" r="3.4" fill="url(#acg)" />
  </svg>
);

export const Logo = ({ className = "" }) => (
  <a
    href="#top"
    data-testid="site-logo"
    className={`group inline-flex items-center gap-2.5 ${className}`}
  >
    <LogoMark />
    <span className="font-display text-[1.05rem] font-600 tracking-tight text-white">
      Arca<span className="text-white/60 group-hover:text-white transition-colors duration-300">Centum</span>
    </span>
  </a>
);
